
import { Options, Prop, Vue } from "vue-property-decorator";
@Options({})
export default class extends Vue {
  @Prop({ required: true }) personInfo: any;
}
